import React from "react";
import logo from "./auth/logo/logo.png";
import "./ContactShop.css";

const ContactShop = () => {
  const buttons = [
    {
      text: "360 Healthy Shop",
      sub: "เว็บไซต์หลัก",
      icon: "🌐",
      url: "https://360-healthyshop.netlify.app",
      color: "btn-contact-primary",
    },
    {
      text: "LINE SHOP",
      sub: "สั่งซื้อผ่าน LINE",
      icon: "💬",
      url: "https://shop.line.me/@360healthyshop",
      color: "btn-contact-line",
    },
    {
      text: "SHOPEE",
      sub: "ช้อปออนไลน์",
      icon: "🛍️",
      url: "https://shopee.co.th/buyer/login?next=https%3A%2F%2Fshopee.co.th%2F360healthy_shop",
      color: "btn-contact-shopee",
    },
    {
      text: "LAZADA",
      sub: "ช้อปออนไลน์",
      icon: "🛒",
      url: "https://www.lazada.co.th/shop/360healthyshop",
      color: "btn-contact-lazada",
    },
    {
      text: "TIKTOK",
      sub: "ติดตามเราบน TikTok",
      icon: "🎵",
      url: "https://www.tiktok.com/@360healthyshop",
      color: "btn-contact-tiktok",
    },
    {
      text: "Line @360healthy",
      sub: "ติดต่อโดยตรง",
      icon: "📱",
      url: "https://line.me/R/ti/p/@buo6340m?oat_content=url",
      color: "btn-contact-line2",
    },
  ];

  return (
    <div className="contact-page">
      {/* Hero */}
      <div className="contact-hero">
        <img src={logo} alt="360 Healthy Shop" className="contact-logo" />
        <h2 className="contact-title">360 Healthy Shop</h2>
        <p className="contact-subtitle">ช่องทางการสั่งซื้อและติดต่อเรา</p>
      </div>

      {/* Buttons */}
      <div className="contact-buttons">
        {buttons.map((btn, index) => (
          <button
            key={index}
            className={`btn-contact ${btn.color}`}
            onClick={() => window.open(btn.url, "_blank")}
          >
            <span className="btn-contact-icon">{btn.icon}</span>
            <div className="btn-contact-text">
              <span className="btn-contact-main">{btn.text}</span>
              <span className="btn-contact-sub">{btn.sub}</span>
            </div>
            <span className="btn-contact-arrow">→</span>
          </button>
        ))}
      </div>

      <p className="contact-footer-text">
        © 2024 360 Healthy Shop · สุขภาพดีมีได้ทุกวัน
      </p>
    </div>
  );
};

export default ContactShop;